import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ImportContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${pxToRem('40px')} ${pxToRem('20px')};
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `};
`;

export const TitleContainer = styled.div`
  text-align: ${props => props.titleAlign};
  padding-bottom: ${pxToRem('10px')};
`;

export const ItemContainer = styled.div`
  padding-top: ${pxToRem('10px')};
`;

export const LinkContainer = styled.div`
  margin: ${pxToRem('25px')} 0;
`;

export const LinkWrapper = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('16px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #467afb;
  text-decoration: underline;
  margin: ${pxToRem('20px')} 0;
  cursor: pointer;
`;

export const DragDropContainer = styled.div`
  height: ${props => pxToRem(props.height)};
  border-radius: ${pxToRem('16px')};
  border: solid ${pxToRem('2px')} #8e8e93;
  background-color: rgba(142, 142, 147, 0.08);
  border-style: dashed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FileDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${pxToRem('10px')};
`;

export const FileContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & > span:is(:first-child) {
    max-width: 100%;
    overflow: auto;
    margin-right: ${pxToRem('8px')};
  }
`;

export const DeleteIcon = styled.div`
  width: ${pxToRem('20px')};
  height: ${pxToRem('20px')};
  cursor: pointer;
  color: ${props => props.theme.colors.mainBlue};
`;

export const InputContainer = styled.input`
  position: relative;
  opacity: 0;
  position: relative;
  top: -30%;
  left: 16%;
`;
export const UploadLink = styled.div`
  position: relative;
  overflow: hidden;
  text-decoration: underline;
  padding-top: ${pxToRem('10px')};

  ${props =>
      props.blueLink &&
      css`
        text-decoration: none;
        color: ${props.theme.colors.blue.one};
      `}
    :hover {
    cursor: pointer;
  }
`;

export const TextContainer = styled.span`
  text-align: center;
`;
export const MaxDimension = styled.div`
  text-align: center;
  > span {
    color: ${props => props.theme.colors.darkGray};
  }
`;
